import { ClearOutlined } from '@ant-design/icons'
import { Button, Form, InputNumber, Select, Table } from 'antd'
import { FC } from 'react'
import { stampShapes } from '../../../../../constants/entity-enums/stamp-shapes'
import useFiltersForm from '../../../../../hooks/forms/use-filters-form'
import Roller from '../../../../../components/form-items/roller/roller'
import MaterialGroups from '../../../../../components/form-items/material-groups/material-groups'

const shapeOptions = stampShapes.map(item => ({
    value: item,
}))

interface FiltersFormProps {}

const FiltersForm: FC<FiltersFormProps> = () => {
    const { form, onSearch, onClear } = useFiltersForm()

    // const [form] = useForm()
    // const [searchParams, setSearchParams] = useSearchParams()
    // // TODO: запросить список валов

    // const filtersString = searchParams.get('filters') || ''

    // useEffect(() => {
    //     const filters = qs.parse(filtersString) as Partial<FormValues>
    //     form.setFieldsValue(filters)
    // }, [filtersString])

    // const setFilters = () => {
    //     const filters = form.getFieldsValue()
    //     // тут устанавливаем новые параметры, так как пагинацию надо сбросить
    //     const searchParams = new URLSearchParams()
    //     const filtersString = qs.stringify(filters)
    //     if (filtersString) searchParams.set('filters', qs.stringify(filters))
    //     setSearchParams(searchParams)
    // }

    // const onClear = () => {
    //     form.resetFields()
    //     setFilters()
    // }

    // const onSearch = async () => {
    //     setFilters()
    // }

    return (
        <Form
            form={form}
            component={false}
            variant={'filled'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                    <Form.Item name={'number'} noStyle>
                        <InputNumber
                            style={{ width: '100%' }}
                            controls={false}
                            placeholder={'Номер'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} />
                <Table.Summary.Cell index={3} />
                <Table.Summary.Cell index={4}>
                    <Roller rules={[]} noStyle />
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} />
                <Table.Summary.Cell index={6} />
                <Table.Summary.Cell index={7} />
                <Table.Summary.Cell index={8} />
                <Table.Summary.Cell index={8.5} />
                <Table.Summary.Cell index={9}>
                    <Form.Item name={'shape'} noStyle>
                        <Select
                            style={{ width: '100%' }}
                            placeholder={'Форма'}
                            options={shapeOptions}
                            mode={'multiple'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11}>
                    <MaterialGroups rules={[]} noStyle />
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11} />
                <Table.Summary.Cell index={12}>
                    <Form.Item name={'externalId'} noStyle>
                        <InputNumber
                            style={{ width: '100%' }}
                            controls={false}
                            placeholder={'Номер'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                {/* <Table.Summary.Cell index={16}>
                    <Form.Item name={'manufacturerId'} noStyle>
                        <InputNumber placeholder={'Идентификатор'} />
                    </Form.Item>
                </Table.Summary.Cell> */}
                <Table.Summary.Cell index={13} />
                <Table.Summary.Cell index={13} />
                <Table.Summary.Cell index={14} />
                {/* <Table.Summary.Cell index={18}>
                    <Form.Item name={'manager'} noStyle>
                        <Select style={{ width: '100%' }} placeholder={'Менеджер'} />
                    </Form.Item>
                </Table.Summary.Cell> */}
                {/* <Table.Summary.Cell index={19} /> */}
                <Table.Summary.Cell index={20}>
                    <Button
                        size={'small'}
                        icon={<ClearOutlined />}
                        title={'Сбросить фильтры'}
                        onClick={onClear}
                    >
                        Сброс
                    </Button>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Form>
    )
}

export default FiltersForm
